/**
 * @generated SignedSource<<c8f24d2f0070205085dd4767a18b66b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProgramType = "ACCESSORIES_3_D_ACCREDITATION" | "A_A_3_D_ACCREDITATION" | "NONE" | "SOFT_HOME_3_D_ACCREDITATION" | "_3_D_STYLING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserProgramsDisplay$data = {
  readonly programs: ReadonlyArray<ProgramType | null | undefined>;
  readonly " $fragmentType": "UserProgramsDisplay";
};
export type UserProgramsDisplay$key = {
  readonly " $data"?: UserProgramsDisplay$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProgramsDisplay">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserProgramsDisplay",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "programs",
      "storageKey": null
    }
  ],
  "type": "GwtUser",
  "abstractKey": null
};

(node as any).hash = "df19ab5233262390de2ac1976bc4123a";

export default node;
